//Modules
import { Fragment } from 'react'

//Components
import AreasCientificas from './AreasCientificas'

function RamoOuPlanoNovo({ plano, planoNovo }) {
    if (plano.$.ramo !== "") {
        return <p className='course-title-detail'><strong>Ramo: </strong>{plano.$.ramo}</p>;
    } else if (planoNovo) {
        return <p className='course-title-detail'><strong>Plano NOVO</strong></p>;
    }
}

function PlanoEstudos({ plano, index, planoCount }) {

  return (
    <>
        <article className='my-5'>
            <div className="container page">
                <div className="row">
                    <div className="col-md-12">
                        <RamoOuPlanoNovo plano={ plano } planoNovo={ planoCount > 1 && index === (planoCount - 1) } />
                    </div>
                </div>
            </div>
        </article>
        {plano.areas[0]?.area && <AreasCientificas areas={plano.areas[0].area} />}
        <article className='my-5'>
            <div className="container page">
                <div className="row">
                    <div className="col-md-12">                    
                        <p className='course-title-detail'><strong>Plano de Estudos</strong></p>
                        <table className='plano-estudos-detail'>
                            <tbody>
                                <tr>
                                    <th><strong>Código</strong></th>
                                    <th><strong>Unidade Curricular</strong></th>
                                    <th><strong>Ano</strong></th>
                                    <th><strong>Tipo</strong></th>
                                    <th><strong>Área Científica</strong></th>
                                    <th><strong>ECTS</strong></th>
                                </tr>
                                {plano.plano_estudos[0].uc.map((uc) => (  
                                    <Fragment key={uc.$.n_disciplina}>                              
                                        {uc.$.opcao === "false" ?
                                            <tr>
                                                <td>{uc.$.codigo}</td>
                                                <td><a href={uc.$.url} target="_blank" rel="noreferrer">{uc.$.nome}</a></td>
                                                <td>{uc.$.ano}</td>
                                                <td>{"S"+uc.$.semestre}</td>
                                                <td>{uc?.area ? 
                                                    uc.area.map((area, index) => (
                                                        <span key={index}>{area.$.nome}<strong style={{color: "#933cc5"}}>{index !== uc.area.length - 1 ? " | " : ""}</strong></span>
                                                    ))
                                                    : ""}</td>
                                                <td>{uc.$.ects}</td>
                                            </tr>
                                            :  
                                            <tr>
                                                <td colSpan={6} className='opcao'>
                                                    <div className="accordion plano opcao">
                                                        <div className="card cardAccordion">
                                                            <div className="card-header" id={uc.$.nome.replaceAll(" ", "-")}>
                                                                <button className="btn collapsed" type="button" data-toggle="collapse" data-target={`#collapse-${uc.$.nome.replaceAll(" ", "-")}`} aria-expanded="false" aria-controls={`collapse-${uc.$.nome.replaceAll(" ", "-")}`}>
                                                                    <strong>{uc.$.nome}</strong>
                                                                    <span></span>
                                                                </button>
                                                            </div>

                                                            <div id={`collapse-${uc.$.nome.replaceAll(" ", "-")}`} className="collapse" aria-labelledby={uc.$.nome.replaceAll(" ", "-")} >
                                                                <div className="card-body">
                                                                    <table>
                                                                        <tbody>
                                                                            {uc.opcao.map((op, index) => (                                                                        
                                                                                <tr key={op.$.codigo} className={index === uc.opcao.length - 1 ? "no-border" : ""}> 
                                                                                    <td width="20%">{op.$.codigo}</td>
                                                                                    <td width="47.7%"><a href={op.$.url} target="_blank" rel="noreferrer">{op.$.nome}</a></td>
                                                                                    <td width="5.4%">{uc.$.ano}</td>
                                                                                    <td width="5.89%">{"S"+uc.$.semestre}</td>
                                                                                    <td width="14.6%">{uc?.area ? uc.area[0].$.nome : ""}</td>
                                                                                    <td>{uc.$.ects}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>                                        
                                            </tr>                                    
                                        }
                                    </Fragment>
                                ))}
                            </tbody>
                        </table>                        
                    </div>
                </div>
            </div>
        </article>
        {index !== planoCount-1 && <hr />}
    </>
  )
}

export default PlanoEstudos